module.exports = __webpack_public_path__ + "img/communityadminpainpoint1.bf147c46.png";